import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";

export const useGetAllClaimExpensiveService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [claimExpenseSearchQuery, setClaimExpenseSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(claimExpenseSearchQuery);
  const allClaimExpensiveService = useQuery({
    queryKey: [...CACHE_KEYS.CLAIMS_EXPENSE, page, per_page, debouncedQuery],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS?.CLAIMS_EXPENSES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    service: { allClaimExpensiveService },
    states: { claimExpenseSearchQuery, setClaimExpenseSearchQuery },
  };
};
